import React, { useEffect, useRef } from 'react';
import { UsersIcon, BuildingIcon, CheckIcon } from 'lucide-react';
export const TeamsSection = () => {
  const sectionRef = useRef(null);
  const cardRef1 = useRef(null);
  const cardRef2 = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in');
        if (cardRef1.current && cardRef2.current) {
          setTimeout(() => {
            cardRef1.current.classList.add('animate-slide-in-left');
          }, 300);
          setTimeout(() => {
            cardRef2.current.classList.add('animate-slide-in-right');
          }, 500);
        }
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="py-24 bg-gray-50 opacity-0 transition-opacity duration-1000" data-id="element-4369">
      <div className="container mx-auto px-4 md:px-6" data-id="element-4370">
        <div className="max-w-4xl mx-auto mb-16 text-center" data-id="element-4371">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-charcoal tracking-tight" data-id="element-4372">
            Scale Without Limits
          </h2>
          <p className="text-xl text-gray-600" data-id="element-4373">
            Flexible solutions that grow with your business, from small teams to
            global enterprises
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-4374">
          {/* Teams (SMB) */}
          <div ref={cardRef1} className="bg-white rounded-xl p-10 shadow-lg border-2 border-gray-100 relative overflow-hidden opacity-0 translate-x-[-50px] transition-all duration-700 h-full" data-id="element-4375">
            <div className="flex items-center mb-8" data-id="element-4376">
              <div className="w-16 h-16 rounded-full bg-gray-50 flex items-center justify-center mr-4" data-id="element-4377">
                <UsersIcon size={32} className="text-teal" data-id="element-4378" />
              </div>
              <h3 className="text-3xl font-bold text-charcoal" data-id="element-4379">Teams</h3>
            </div>
            <div className="space-y-6 mb-10" data-id="element-4380">
              <p className="text-gray-600 text-lg" data-id="element-4381">
                Perfect for small to medium businesses looking to manage
                compliance training efficiently and effectively.
              </p>
              <ul className="space-y-4" data-id="element-4382">
                <li className="flex items-start" data-id="element-4383">
                  <div className="w-6 h-6 rounded-full bg-gray-50 flex items-center justify-center mt-0.5 mr-3" data-id="element-4384">
                    <CheckIcon className="h-4 w-4 text-teal" data-id="element-4385" />
                  </div>
                  <span className="text-charcoal text-lg" data-id="element-4386">
                    Manager dashboards
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4387">
                  <div className="w-6 h-6 rounded-full bg-gray-50 flex items-center justify-center mt-0.5 mr-3" data-id="element-4388">
                    <CheckIcon className="h-4 w-4 text-teal" data-id="element-4389" />
                  </div>
                  <span className="text-charcoal text-lg" data-id="element-4390">Assign training</span>
                </li>
                <li className="flex items-start" data-id="element-4391">
                  <div className="w-6 h-6 rounded-full bg-gray-50 flex items-center justify-center mt-0.5 mr-3" data-id="element-4392">
                    <CheckIcon className="h-4 w-4 text-teal" data-id="element-4393" />
                  </div>
                  <span className="text-charcoal text-lg" data-id="element-4394">Export reports</span>
                </li>
                <li className="flex items-start" data-id="element-4395">
                  <div className="w-6 h-6 rounded-full bg-gray-50 flex items-center justify-center mt-0.5 mr-3" data-id="element-4396">
                    <CheckIcon className="h-4 w-4 text-teal" data-id="element-4397" />
                  </div>
                  <span className="text-charcoal text-lg" data-id="element-4398">Top-up licences</span>
                </li>
              </ul>
            </div>
            <a href="/teams" className="px-8 py-4 bg-teal text-white font-medium rounded-md hover:bg-gradient-to-r hover:from-teal hover:to-aqua transition-all duration-300 inline-block shadow-lg transform hover:-translate-y-1" data-id="element-4399">
              Train Your Team
            </a>
          </div>
          {/* Enterprise */}
          <div ref={cardRef2} className="bg-gradient-to-br from-teal to-teal/80 rounded-xl p-10 shadow-lg relative overflow-hidden opacity-0 translate-x-[50px] transition-all duration-700 h-full" data-id="element-4400">
            <div className="flex items-center mb-8" data-id="element-4401">
              <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center mr-4" data-id="element-4402">
                <BuildingIcon size={32} className="text-white" data-id="element-4403" />
              </div>
              <h3 className="text-3xl font-bold text-white" data-id="element-4404">Enterprise</h3>
            </div>
            <div className="space-y-6 mb-10" data-id="element-4405">
              <p className="text-white/90 text-lg" data-id="element-4406">
                Tailored solutions for large organizations with complex
                compliance needs and global teams.
              </p>
              <ul className="space-y-4" data-id="element-4407">
                <li className="flex items-start" data-id="element-4408">
                  <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5 mr-3" data-id="element-4409">
                    <CheckIcon className="h-4 w-4 text-white" data-id="element-4410" />
                  </div>
                  <span className="text-white text-lg" data-id="element-4411">
                    White-label academy
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4412">
                  <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5 mr-3" data-id="element-4413">
                    <CheckIcon className="h-4 w-4 text-white" data-id="element-4414" />
                  </div>
                  <span className="text-white text-lg" data-id="element-4415">Custom domain</span>
                </li>
                <li className="flex items-start" data-id="element-4416">
                  <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5 mr-3" data-id="element-4417">
                    <CheckIcon className="h-4 w-4 text-white" data-id="element-4418" />
                  </div>
                  <span className="text-white text-lg" data-id="element-4419">Advanced reporting</span>
                </li>
                <li className="flex items-start" data-id="element-4420">
                  <div className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center mt-0.5 mr-3" data-id="element-4421">
                    <CheckIcon className="h-4 w-4 text-white" data-id="element-4422" />
                  </div>
                  <span className="text-white text-lg" data-id="element-4423">
                    Built-in communities
                  </span>
                </li>
              </ul>
            </div>
            <a href="/enterprise" className="px-8 py-4 bg-white text-teal font-medium rounded-md hover:bg-gray-50 transition-all duration-300 inline-block shadow-lg transform hover:-translate-y-1" data-id="element-4424">
              Book a Demo
            </a>
            {/* Decorative elements */}
            <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-white/10 rounded-full" data-id="element-4425"></div>
            <div className="absolute -bottom-10 -right-10 w-48 h-48 bg-white/10 rounded-full" data-id="element-4426"></div>
          </div>
        </div>
      </div>
      <style jsx data-id="element-4427">{`
        .animate-slide-in-left {
          opacity: 1;
          transform: translateX(0);
        }
        .animate-slide-in-right {
          opacity: 1;
          transform: translateX(0);
        }
      `}</style>
    </section>;
};